"use client";
import { useState } from "react";
import DrawerImpostazioni from './drawers/DrawerImpostazioni';
import DrawerArchivista from './drawers/DrawerArchivista';

export type RightDrawerContent = 'impostazioni' | 'dati' | null;

export function useDrawers() {
  const [rightContent, setRightContent] = useState<RightDrawerContent>(null);

  return {
    leftOpen: false,
    rightOpen: rightContent !== null,
    rightContent,
    openLeft: () => {},
    closeLeft: () => {},
    openDati: () => setRightContent('dati'),
    openDocs: () => {},
    openImpostazioni: () => setRightContent('impostazioni'),
    closeRight: () => setRightContent(null),
  };
}

type Conv = { id: string; title: string };

export function DrawersWithBackdrop({
  leftOpen,
  rightOpen,
  rightContent,
  onCloseLeft,
  onCloseRight,
  onSelectConversation,
}: {
  leftOpen: boolean;
  rightOpen: boolean;
  rightContent: RightDrawerContent;
  onCloseLeft: () => void;
  onCloseRight: () => void;
  onSelectConversation?: (c: Conv) => void;
}) {
  return (
    <>
      {rightOpen && (
        <div
          onClick={onCloseRight}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1999,
            cursor: 'pointer',
          }}
        />
      )}
      <div style={{ position: 'relative', zIndex: 2001 }}>
        {rightContent === 'impostazioni' && (
          <aside className="drawer right open">
            <DrawerImpostazioni onClose={onCloseRight} />
          </aside>
        )}
        {rightContent === 'dati' && (
          <aside className="drawer right open">
            <DrawerArchivista onClose={onCloseRight} />
          </aside>
        )}
      </div>
    </>
  );
}